module.exports = __webpack_public_path__ + "static/img/product.9a7d19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/product.png
// module id = uW3H
// module chunks = 0